module.exports = __webpack_public_path__ + "img/1.5.d2e22e26.png";